// eslint-disable-next-line import/prefer-default-export

export const pvsystMutations = {

    SET_INPUT_DATA: (state, payload) => {
        state.inputData = payload
    },
    SET_GLOBAL_INCLINE: (state, payload) => {
        state.globalIncline = payload
    },
    SET_ENERGIE_COMPTEUR_AC: (state, payload) => {
        state.energieCompteurAC = payload
    }

};